import { cn } from '../../lib/utils';
import { HTMLAttributes, forwardRef } from 'react';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: 'default' | 'primary' | 'secondary' | 'success' | 'danger' | 'warning';
}

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(
  ({ className, variant = 'default', ...props }, ref) => {
    return (
      <span
        ref={ref}
        className={cn(
          'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
          {
            'bg-primary/10 text-primary': variant === 'primary',
            'bg-secondary/10 text-secondary': variant === 'secondary',
            'bg-success/10 text-success': variant === 'success',
            'bg-danger/10 text-danger': variant === 'danger',
            'bg-warning/10 text-warning': variant === 'warning',
            'bg-background text-text-muted': variant === 'default',
          },
          className,
        )}
        {...props}
      />
    );
  },
);

Badge.displayName = 'Badge';
